export const GET_WEB3 = 'GET_WEB3';
export const GET_CONTRACT = 'GET_CONTRACT';
export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const GET_NETWORK = 'GET_NETWORK';
export const BALANCE = 'BALANCE';
export const CONTRACT_BALANCE='CONTRACT_BALANCE';

//ALERT
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
